/* Rquiere de mixin.js */

var storeRackSideRowColumn = {
	data () {
		return {
			listStoreRackSideRowColumns: [],
			methodsStoreRackSideRowColumn: {
				get: 'storeRackSideRowColumns',
				show: 'storeRackSideRowColumn/',
			},
            objectStoreRackSideRowColumn: {
                exist: 0,
                id: 0,
                name: '',
                store_id: 0,
                store: {},
                store_rack_id: 0,
                store_rack: {},
                store_rack_side_id: 0,
                store_rack_side: {},
                products: [],
                created_at: '',
                updated_at: ''
            },
			paginationStoreRackSideRowColumns: [],
			searchStoreRackSideRowColumns: '',
            searchingStoreRackSideRowColumn: false,
			storeRackSideRowColumnIdSelected: 0
		}
	},
	computed: {
	},
	filters: {
	},
	methods:{
		clearObjectStoreRackSideRowColumn() {
			this.objectStoreRackSideRowColumn.exist = 0
			this.objectStoreRackSideRowColumn.id = 0
			this.objectStoreRackSideRowColumn.name = ''
			this.objectStoreRackSideRowColumn.store_id = 0
			this.objectStoreRackSideRowColumn.store = {}
			this.objectStoreRackSideRowColumn.store_rack_id = 0
			this.objectStoreRackSideRowColumn.store_rack = {}
			this.objectStoreRackSideRowColumn.store_rack_side_id = 0
			this.objectStoreRackSideRowColumn.store_rack_side = {}
			this.objectStoreRackSideRowColumn.products = []
			this.objectStoreRackSideRowColumn.created_at = ''
			this.objectStoreRackSideRowColumn.updated_at = ''
		},
		getAllStoreRackSideRowColumns(page = 1) {
			this.searchingStoreRackSideRowColumn = true
			this.listStoreRackSideRowColumns = []
			let parameters = '?search=' + this.searchStoreRackSideRowColumns + '&page=' + page
			this.axiosActionIS(this.apiBackend + this.methodsStoreRackSideRowColumn.get + parameters, 'GET', 'getAllStoreRackSideRowColumnsResult')
        },
		getAllStoreRackSideRowColumnsResult(response) {
			this.searchingStoreRackSideRowColumn = false
			if(response.data.success == true) {
				this.listStoreRackSideRowColumns = response.data.data
			}
            this.getAllStoreRackSideRowColumnsResultLocal(response)
		},
        getAllStoreRackSideRowColumnsResultLocal(response) {
            console.log('getAllStoreRackSideRowColumnsResultLocal no desarrollado', response)
        },
		getStoreRackSideRowColumn(id) {
			let url = this.apiBackend + this.methodsStoreRackSideRowColumn.show + id
			this.axiosActionIS(this.apiBackend + this.methodsStoreRackSideRowColumn.show + id, 'GET', 'getStoreRackSideRowColumnResult')
		},
        getStoreRackSideRowColumnResult(response) {
			this.getStoreRackSideRowColumnResultLocal(response)
        },
        getStoreRackSideRowColumnResultLocal(response) {
            console.log('getStoreRackSideRowColumnResultLocal no está desarrollado', response)
        },
        setObjectStoreRackSideRowColumn(item) {
			for (const property in item) {
				this.objectStoreRackSideRowColumn[property] = item[property]
			}
        },
		showStoreRackSideRowColumn(id) {
			this.searchingStoreRackSideRowColumn = true
			this.clearObjectStoreRackSideRowColumn()
			let url = this.apiBackend + this.methodsStoreRackSideRowColumn.show + id
			this.axiosActionIS(url, 'GET', 'showStoreRackSideRowColumnResult')
		},
		showStoreRackSideRowColumnResult(response) {
			this.searchingStoreRackSideRowColumn = false
			if(response.data.success == true) {
				this.setObjectStoreRackSideRowColumn(response.data.data)
			}
			this.showStoreRackSideRowColumnResultLocal(response)
		},
		showStoreRackSideRowColumnResultLocal(response) {
			console.log('showStoreRackSideRowColumnResultLocal no desarrollado', response)
		}
	},
};

export default storeRackSideRowColumn;